import {
  TERMINAL_MODEL_ADD_REQUEST,
  TERMINAL_MODEL_ADD_REQUEST_SUCCESS,
  TERMINAL_MODEL_ADD_REQUEST_FAILURE,
  TERMINAL_MODEL_FETCH_REQUEST,
  TERMINAL_MODEL_FETCH_REQUEST_SUCCESS,
  TERMINAL_MODEL_FETCH_REQUEST_FAILURE,
  TERMINAL_MODEL_CLEAN_REQUEST,
  TERMINAL_MODEL_UPDATE_REQUEST,
  TERMINAL_MODEL_UPDATE_REQUEST_SUCCESS,
  TERMINAL_MODEL_UPDATE_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalModelsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_MODEL_FETCH_REQUEST:
    case TERMINAL_MODEL_ADD_REQUEST:
    case TERMINAL_MODEL_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_MODEL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case TERMINAL_MODEL_ADD_REQUEST_SUCCESS:
    case TERMINAL_MODEL_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_MODEL_FETCH_REQUEST_FAILURE:
    case TERMINAL_MODEL_ADD_REQUEST_FAILURE:
    case TERMINAL_MODEL_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_MODEL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default terminalModelsReducer;
